namespace RedBullMOBILE360.PushNotifications {
    export interface PushNotificationsExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
        SendNow: Serenity.BooleanEditor;
        SendDate: Serenity.DateTimeEditor;
    }

    export class PushNotificationsExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'PushNotifications.PushNotificationsExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PushNotificationsExcelImportForm.init)  {
                PushNotificationsExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DateTimeEditor;

                Q.initFormType(PushNotificationsExcelImportForm, [
                    'FileName', w0,
                    'SendNow', w1,
                    'SendDate', w2
                ]);
            }
        }
    }
}
